
const testing = false;
const live = true;
const SERVER_URL = live ? process.env.REACT_APP_SERVER_URL : 'https://pace-59-nceh.vercel.app/';
const LIVE_URL = testing ? 'http://localhost:3001/' : SERVER_URL;

export default LIVE_URL;